import * as React from 'react';

import PageHeader from '../../components/page-header';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import IdentityService, { FormEntries } from '../../services/identity-service';
import { TOSS_STANDARD_AUTH } from '../../store/constants';
import './index.styl';

declare const TossCert: any;

const queryString = require('query-string');

export type AppProps = RouteComponentProps<any> & InjectedTranslateProps;

export interface AppState {
  error?: String;
  authMethodTypes: string[];
  apiVersion: string;
}

class IdentityVerifier extends React.Component<AppProps, AppState> {
  constructor(props) {
    super(props);

    this.state = {
      authMethodTypes: [],
      apiVersion: '',
    };
  }

  componentDidMount(): void {
    const { t } = this.props;
    const search = queryString.parse(this.props.location.search);

    IdentityService.getBaseInformations(search.serviceType)
      .then((resp) => {
        this.setState({
          authMethodTypes: resp.authMethodTypes,
          apiVersion: resp.version,
        });
      })
      .catch(() => {
        alert(t('error-message-invalid-usage'));
      });
  }

  private startTossIdentityVerify(targetUrl, formEntries: FormEntries) {
    const tossCert = TossCert();

    tossCert.start({
      type: 'redirect',
      authUrl: targetUrl,
      txId: formEntries.txId,
      successUrl: formEntries.successUrl,
      failUrl: formEntries.failUrl,
    });
  }

  private startIdentityVerify(providerType: string) {
    const { t } = this.props;
    const search = queryString.parse(this.props.location.search);
    IdentityService.getIdentityProvider(
      providerType,
      search.serviceType,
      search.callbackUrl
    )
      .then((resp) => {
        if (providerType === TOSS_STANDARD_AUTH) {
          this.startTossIdentityVerify(resp.targetUrl, resp.formEntries);
          return;
        }
        const identityForm = document.forms['identity-form'];
        identityForm.action = resp.targetUrl;
        identityForm.method = 'POST';

        for (const [key, value] of Object.entries(resp.formEntries)) {
          const input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', key);
          input.setAttribute('value', value);
          identityForm.appendChild(input);
        }

        identityForm.submit();
      })
      .catch(() => {
        alert(t('error-message-invalid-usage'));
      });
  }

  private createMockAuthButton(serviceType: string, callbackUrl?: string) {
    const { t, history, match } = this.props;
    const mock =
      process.env.NODE_ENV !== 'production' ? (
        <button
          type='submit'
          className='button large'
          onClick={() => {
            let path = `/${match.params.lang}/mock?serviceType=${serviceType}`;
            if (callbackUrl) {
              path = `${path}&callbackUrl=${encodeURIComponent(callbackUrl)}`;
            }
            history.push(path);
          }}>
          {t('mock')}
        </button>
      ) : (
        ''
      );
    return mock;
  }

  render() {
    const { t } = this.props;
    const search = queryString.parse(this.props.location.search);
    const mockAuthButton = this.createMockAuthButton(
      search.serviceType,
      search.callbackUrl
    );

    return (
      <div className='container'>
        <PageHeader
          i18nHeader='self-auth-title'
          i18nSubHeader='self-auth-sub-title'
        />
        <section>
          {this.state.authMethodTypes.map((providerType: string) => {
            return (
              <button
                key={`button-${providerType}`}
                type='submit'
                className='button large'
                onClick={(e) => {
                  e.preventDefault();
                  this.startIdentityVerify(providerType);
                }}>
                {t(providerType.toLowerCase())}
              </button>
            );
          })}
          {mockAuthButton}
          <form id='identity-form' />
          <div className='version'>
            <div>API-{this.state.apiVersion}</div>
            <div>VERSION-{process.env.APP_VERSION || 'development'}</div>
          </div>
        </section>
      </div>
    );
  }
}

export default compose(
  withRouter,
  translate(),
  connect()
)(IdentityVerifier);



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/identity-verifier/index.tsx